// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Scrollable$Showside from "../Scrollable.bs.js";
import * as ReactDOMUtils$Showside from "../../utils/ReactDOMUtils.bs.js";
import * as NavMenu__Items$Showside from "./NavMenu__Items.bs.js";
import * as RouterProvider$Showside from "../../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../../context/ViewportContext.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as NavMenu__Sidebar$Showside from "./NavMenu__Sidebar.bs.js";
import * as NavMenu__Sections$Showside from "./NavMenu__Sections.bs.js";
import * as NavMenu__Transition$Showside from "./NavMenu__Transition.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
function make(Props) {
  var level = Props.level;
  var category = Props.category;
  var disabled = Props.disabled;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  RouterProvider$Showside.useRouter(undefined);
  var items = NavMenu__Items$Showside.useItems(category, undefined);
  ViewportContext$Showside.use(undefined);
  var scrollableContainerRef = React.useRef(null);
  var match$1 = React.useState(function () {
    return ctx.currentFullPath;
  });
  var setRelativePath = match$1[1];
  var relativePath = match$1[0];
  React.useEffect(function () {
    Curry._1(setRelativePath, function (previous) {
      if (Belt_Array.some(ctx.currentFullPath, function (c) {
        return c.id === category.id;
      })) {
        return ctx.currentFullPath;
      } else {
        return previous;
      }
    });
  }, [ctx.currentFullPath]);
  var __categoryIndex = Belt_Option.map(Belt_Option.keep(Belt_Option.flatMap(items, function (items) {
    return Belt_Array.getIndexBy(items, function (i) {
      return Caml_obj.equal(i.category.id, Belt_Option.map(Belt_Option.orElse(Belt_Array.get(relativePath, level), Belt_Array.get(relativePath, level - 1 | 0)), function (c) {
        return c.id;
      }));
    });
  }), function (i) {
    return i >= 0;
  }), function (i) {
    return i + 1 | 0;
  });
  var match$2 = React.useState(function () {
    return Belt_Option.getWithDefault(__categoryIndex, 0);
  });
  var setCategoryIndex = match$2[1];
  React.useEffect(function () {
    Curry._1(setCategoryIndex, function (previous) {
      return Belt_Option.getWithDefault(__categoryIndex, previous);
    });
  }, [__categoryIndex, disabled]);
  var match$3 = ctx.mode;
  var sidebarWidth = match$3 ? 120 : 200;
  var isAnyItemVisible = Belt_Array.some(Belt_Option.getWithDefault(items, []), function (i) {
    if (i.isHidden === false) {
      return i.isParentItself === false;
    } else {
      return false;
    }
  });
  var canRenderSidebar = (ctx.threeColumnLayout || level === 1) && config.settings.linksAsSidebar && isAnyItemVisible;
  var canRenderNextLevel = level !== relativePath.length && level < (ctx.maxLevels - 1 | 0);
  var tmp;
  if (canRenderSidebar) {
    var tmp$1 = {
      level: level,
      className: CSS$Showside.prefix("flex-shrink-0"),
      style: {
        width: CSS$Showside.intToPx(sidebarWidth)
      }
    };
    if (items !== undefined) {
      tmp$1.items = Caml_option.valFromOption(items);
    }
    tmp = React.createElement(NavMenu__Sidebar$Showside.make, tmp$1);
  } else {
    tmp = null;
  }
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(scrollableContainerRef),
    className: CSS$Showside.prefix(Cn.make(["flex h-full relative", ctx.mode === /* Hamburger */1 ? "overflow-hidden" : ""]))
  }, tmp, React.createElement("div", {
    className: CSS$Showside.prefix("flex-grow relative")
  }, React.createElement(NavMenu__Transition$Showside.Container.make, {
    value: match$2[0],
    direction: /* Vertical */0,
    disabled: disabled,
    children: Belt_Array.mapWithIndex(Belt_Option.getWithDefault(items, []), function (index, param) {
      var category = param.category;
      return React.createElement(NavMenu__Transition$Showside.Content.make, {
        value: index + 1 | 0,
        dataTestId: "nav-menu-content-l2",
        className: CSS$Showside.prefix("h-full"),
        children: canRenderNextLevel ? React.createElement(make, {
          level: level + 1 | 0,
          category: category,
          disabled: disabled
        }) : React.createElement(Scrollable$Showside.make, {
          children: React.createElement(NavMenu__Sections$Showside.make, {
            allCategories: config.categories,
            category: category,
            scrollableContainerRef: scrollableContainerRef
          }),
          className: CSS$Showside.prefix("relative h-full no-scrollbar pb-20"),
          rememberScrollPosition: false
        }),
        key: category.id
      });
    })
  })));
}
make.displayName = "make";
var make$1 = React.memo(make);
export { make$1 as make };
/* make Not a pure module */